module.exports = __webpack_public_path__ + "static/media/pg84-85.689043d4.jpg";